/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Security_Issue_LinkInputs */

const en_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report a security issue`)
};

const id_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laporkan masalah keamanan`)
};

const ms_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laporkan isu keselamatan`)
};

const ca_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informar d'un problema de seguretat`)
};

const cs_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahlásit bezpečnostní problém`)
};

const da_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapportér et sikkerhedsproblem`)
};

const de_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Sicherheitslücke melden`)
};

const et_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teatage turvaprobleemist`)
};

const es_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informar sobre un problema de seguridad`)
};

const fr_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signaler un problème de sécurité`)
};

const hr_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijavite sigurnosni problem`)
};

const it_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segnala un problema di sicurezza`)
};

const lv_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziņot par drošības problēmu`)
};

const lt_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praneškite apie saugumo problemą`)
};

const hu_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biztonsági probléma jelentése`)
};

const nl_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een beveiligingsprobleem melden`)
};

const nb_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meld fra om et sikkerhetsproblem`)
};

const pl_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgłoś problem dotyczący bezpieczeństwa`)
};

const pt_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informar um problema de segurança`)
};

const ro_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raportează o problemă de securitate`)
};

const sk_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahlásiť bezpečnostný problém`)
};

const sl_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijava varnostnega problema`)
};

const fi_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoita turvallisuusongelmasta`)
};

const sv_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapportera ett säkerhetsproblem`)
};

const vi_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Báo cáo vấn đề bảo mật`)
};

const tr_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir güvenlik sorunu bildirin`)
};

const el_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αναφορά ζητήματος ασφαλείας`)
};

const bg_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Докладвай проблем със сигурността`)
};

const ru_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщить о проблеме с безопасностью`)
};

const sr_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пријавите безбедносни проблем`)
};

const uk_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повідомити про проблему безпеки`)
};

const ka_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`უსაფრთხოების პრობლემის შეტყობინება`)
};

const hi_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सुरक्षा से जुड़ी समस्या की रिपोर्ट करें`)
};

const th_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แจ้งปัญหาความปลอดภัย`)
};

const ko_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보안 문제 신고`)
};

const zh_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`举报安全问题`)
};

const zh_tw_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`舉報安全問題`)
};

const ja_report_security_issue_link = /** @type {(inputs: Report_Security_Issue_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セキュリティの問題を報告`)
};

/**
* | output |
* | --- |
* | "Report a security issue" |
*
* @param {Report_Security_Issue_LinkInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const report_security_issue_link = /** @type {((inputs?: Report_Security_Issue_LinkInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Security_Issue_LinkInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_report_security_issue_link(inputs)
	if (locale === "ms") return ms_report_security_issue_link(inputs)
	if (locale === "ca") return ca_report_security_issue_link(inputs)
	if (locale === "cs") return cs_report_security_issue_link(inputs)
	if (locale === "da") return da_report_security_issue_link(inputs)
	if (locale === "de") return de_report_security_issue_link(inputs)
	if (locale === "et") return et_report_security_issue_link(inputs)
	if (locale === "es") return es_report_security_issue_link(inputs)
	if (locale === "fr") return fr_report_security_issue_link(inputs)
	if (locale === "hr") return hr_report_security_issue_link(inputs)
	if (locale === "it") return it_report_security_issue_link(inputs)
	if (locale === "lv") return lv_report_security_issue_link(inputs)
	if (locale === "lt") return lt_report_security_issue_link(inputs)
	if (locale === "hu") return hu_report_security_issue_link(inputs)
	if (locale === "nl") return nl_report_security_issue_link(inputs)
	if (locale === "nb") return nb_report_security_issue_link(inputs)
	if (locale === "pl") return pl_report_security_issue_link(inputs)
	if (locale === "pt") return pt_report_security_issue_link(inputs)
	if (locale === "ro") return ro_report_security_issue_link(inputs)
	if (locale === "sk") return sk_report_security_issue_link(inputs)
	if (locale === "sl") return sl_report_security_issue_link(inputs)
	if (locale === "fi") return fi_report_security_issue_link(inputs)
	if (locale === "sv") return sv_report_security_issue_link(inputs)
	if (locale === "vi") return vi_report_security_issue_link(inputs)
	if (locale === "tr") return tr_report_security_issue_link(inputs)
	if (locale === "el") return el_report_security_issue_link(inputs)
	if (locale === "bg") return bg_report_security_issue_link(inputs)
	if (locale === "ru") return ru_report_security_issue_link(inputs)
	if (locale === "sr") return sr_report_security_issue_link(inputs)
	if (locale === "uk") return uk_report_security_issue_link(inputs)
	if (locale === "ka") return ka_report_security_issue_link(inputs)
	if (locale === "hi") return hi_report_security_issue_link(inputs)
	if (locale === "th") return th_report_security_issue_link(inputs)
	if (locale === "ko") return ko_report_security_issue_link(inputs)
	if (locale === "zh") return zh_report_security_issue_link(inputs)
	if (locale === "zh-tw") return zh_tw_report_security_issue_link(inputs)
	if (locale === "ja") return ja_report_security_issue_link(inputs)
	return en_report_security_issue_link(inputs)
});